module.exports = __webpack_public_path__ + "img/logo-hamrahe-aval.7b3dee9.svg";